import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function Impressum() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col" data-id="element-187">
      <Header forceSolid={true} data-id="element-188" />
      <main className="flex-grow pt-32 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-190">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-191">
            Impressum
          </h1>

          <div className="space-y-8 text-slate-600" data-id="element-192">
            <section data-id="element-193">
              <p className="mb-2" data-id="element-194">Uwe Ellner</p>
              <p className="mb-2" data-id="element-195">ellner consultancy (Einzelunternehmer)</p>
              <p className="mb-2" data-id="element-196">Tulpenweg 5</p>
              <p className="mb-2" data-id="element-197">65451 Kelsterbach</p>
            </section>

            <section data-id="element-198">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-199">
                Kontakt
              </h2>
              <p className="mb-2" data-id="element-200">Telefon: +49 (0) 1704502536</p>
              <p className="mb-2" data-id="element-201">Telefax: +49 (0) 32221340517</p>
              <p className="mb-2" data-id="element-202">E-Mail: info@ellnerconsult.de</p>
            </section>

            <section data-id="element-203">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-204">
                Umsatzsteuer-ID
              </h2>
              <p className="mb-2" data-id="element-205">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
              </p>
              <p data-id="element-206">[DE284109327]</p>
            </section>

            <section data-id="element-207">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-208">
                Redaktionell verantwortlich
              </h2>
              <p className="mb-2" data-id="element-209">Uwe Ellner</p>
              <p className="mb-2" data-id="element-210">Tulpenweg 5</p>
              <p className="mb-2" data-id="element-211">65451 Kelsterbach</p>
            </section>
            <section data-id="element-212">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-213">
                Haftungsausschluss
              </h2>
              <p className="mb-2" data-id="element-214">Wir sind für die Inhalte unserer Internetseiten nach den Maßgaben der allgemeinen Gesetzen verantwortlich. Alle Inhalte werden mit der gebotenen Sorgfalt und nach bestem Wissen erstellt. Soweit wir auf unseren Internetseiten mittels Hyperlink auf Internetseiten Dritter verweisen, können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit und Vollständigkeit der verlinkten Inhalte übernehmen, da diese Inhalte außerhalb unseres Verantwortungsbereichs liegen und wir auf die zukünftige Gestaltung keinen Einfluss haben. Sollten aus Ihrer Sicht Inhalte gegen geltendes Recht verstoßen oder unangemessen sein, teilen Sie uns dies bitte mit.
Die rechtlichen Hinweise auf dieser Seite sowie alle Fragen und Streitigkeiten im Zusammenhang mit der Gestaltung dieser Internetseite unterliegen dem Recht der Bundesrepublik Deutschland.</p>
              
              </section>
              <section data-id="element-215">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-216">
                Datenschutzhinweis
              </h2>
              <p className="mb-2" data-id="element-217">Unsere Datenschutzerklärung finden Sie unter: <a href="https://ellnerconsult.de/#/datenschutz" data-id="element-218">https://ellnerconsult.de/#/datenschutz</a></p>
              </section>
              <section data-id="element-219">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-220">
                Urheberrechtshinweis
              </h2>
              <p className="mb-2" data-id="element-221">Die auf unserer Internetseite vorhandenen Texte, Bilder, Fotos, Videos oder Grafiken unterliegen in der Regel dem Schutz des Urheberrechts. Jede unberechtigte Verwendung (insbesondere die Vervielfältigung, Bearbeitung oder Verbreitung) dieser urheberrechtsgeschützten Inhalte ist daher untersagt. Wenn Sie beabsichtigen, diese Inhalte oder Teile davon zu verwenden, kontaktieren Sie uns bitte im Voraus unter den oben stehenden Angaben. Soweit wir nicht selbst Inhaber der benötigten urheberrechtlichen Nutzungsrechte sein sollten, bemühen wir uns, einen Kontakt zum Berechtigten zu vermitteln.</p>
              </section>
            <div className="p-4 bg-blue-50 border border-blue-100 rounded-lg text-sm text-blue-800 mt-8" data-id="element-222">
             ./.
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-223" />
    </div>;
}